export default __webpack_public_path__ + "static/Acropolis_Athens_Greece-61c542d070f80676c1f9133eaedca62e.jpg";